
$(function() {
    $('.inview-fadein').on('inview', function() {
        $(this).toggleClass('FadeIn');
         var st0 = document.querySelectorAll('.st0');
        var anime = function() {
            new Vivus('svg-animation', { type: 'scenario-sync', duration: 100, forceRender: false, animTimingFunction: Vivus.EASE }, function() {
                setTimeout(function() {
                    for (var i = 0; i < st0.length; i++)
                        st0[i].removeAttribute('style');
                }, 500)
            });
        }
        anime();
    });
});


$('.inview-fadein').on('inview', function() {
let mySwiper00 = new Swiper('#swiper_works', { //この例では id のセレクタを指定して初期化
  // デフォルトの設定
  slidesPerView: 1,
  spaceBetween: 30,
  loopFillGroupWithBlank: true,
  loop: true,
  // レスポンシブブレーポイント（画面幅による設定）
  breakpoints: {

    640: {
      slidesPerView: 1,
      spaceBetween: 40
    }
  },

  navigation: {  //ナビゲーションボタンを表示
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
//トップページのニューススライダー ===================================
let mySwiper01 = new Swiper('#swiper_news', { //この例では id のセレクタを指定して初期化
    // デフォルトの設定
  slidesPerView: 4,
  spaceBetween: 30,
  loopFillGroupWithBlank: true,

  speed:900,

  breakpoints: {
    // 画面幅が 480px 以上の場合（window width >= 640px）
    640: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    // 画面幅が 640px 以上の場合（window width >= 640px）
    768: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    // 画面幅が 960px 以上の場合（window width >= 980px）
    960: {
      slidesPerView: 3,
      spaceBetween: 20
    }
  },
  // pagination: {
  //   el: '.swiper-pagination',
  //   clickable: true,
  // },
  navigation: {  //ナビゲーションボタンを表示
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
//トップページのThe BEST EVENTスライダー ===================================
let mySwiper02 = new Swiper('#swiper_thebestevent', { //この例では id のセレクタを指定して初期化
  // デフォルトの設定
  slidesPerView: 1,
  spaceBetween: 30,
  loopFillGroupWithBlank: true,
  loop: true,
  // レスポンシブブレーポイント（画面幅による設定）
  breakpoints: {

    640: {
      slidesPerView: 1,
      spaceBetween: 40
    }
  },

  navigation: {  //ナビゲーションボタンを表示
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
});
